/**
 * MiniTablePro shared constants.
 */

/** Shared red color for warnings, delete UI, clear buttons, error text */
export const RED_PRIMARY = "#991b1b";

/** Border radius for dialog footer buttons (Cancel, Update) — keep consistent across MiniTablePro dialogs */
export const DIALOG_BUTTON_BORDER_RADIUS = "8px";

/** Min height for dialog footer buttons (current height + ~10%) — same across MiniTablePro and ErrorDialog */
export const DIALOG_BUTTON_MIN_HEIGHT = "30px";

/** Max properties allowed in the table (Add button disabled when reached) */
export const MINI_TABLE_MAX_PROPERTIES = 12;

/** Keys on quarterlyAreaTable that hold property lists (combined for Add Property dialog) */
export const QUARTERLY_AREA_PROPERTY_KEYS = [
  "activePhotoDetailsList",
  "contingentPhotoDetailsList",
  "pendingPhotoDetailsList",
  "preSoldPhotoDetailsList",
  "recentSoldPhotoDetailsList",
  "agentFilteredPhotoDetailsList",
  "comingSoonSoldPhotoDetailsList",
];

/** Property type display labels (key → short label) */
export const PROPERTY_TYPE_OPTIONS = {
  "Single Family Home": "Sgl Family",
  "Condo": "Condo",
  "Condo/Co-Op": "Condo/Co-Op",
  "Townhouse": "Townhouse",
  "Multi-Plex": "Multi-Plex",
  "Mfg. Homes": "Mfg. Home",
};

/** Status options for add/edit property form (value, label, colors) */
export const STATUS_OPTIONS = [
  { value: "Active", label: "Active", text: "#004fac", selectedBg: "#004fac" },
  { value: "Pending", label: "Pending", text: "#c39c6a", selectedBg: "#c39c6a" },
  { value: "Sold", label: "Sold", text: "#6aa68b", selectedBg: "#6aa68b" },
  { value: "Coming Soon", label: "Coming Soon!", text: "rgb(222, 81, 50)", selectedBg: "rgb(222, 81, 50)" },
  { value: "ActiveContingent", label: "Active - Contingent", text: "#004fac", selectedBg: "#004fac" },
  { value: "Contingent", label: "Contingent", text: "#004fac", selectedBg: "#004fac" },
];

/** Max length for address field in add/edit property */
export const ADDRESS_MAX_LENGTH = 35;

/** Max length for custom property type text in add/edit dialog */
export const CUSTOM_PROPERTY_TYPE_MAX_LENGTH = 20;

/** Maximum list/sale price ($999,000,000) for add/edit validation and input clamping */
export const MAX_LIST_SALE_PRICE = 999_000_000;

/** Combined character budget per footer-disclaimer pair (1&2, 3&4) in Edit Table Footer dialog */
export const DISCLAIMER_PAIR_CHAR_LIMIT = 150;
